import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";

import CampaignTemplateSection from "../CampaignModal/components/CampaignTemplateSection";
import { useMetaCampaignModal } from "./useMetaCampaignModal";

const useStyles = makeStyles((theme) => ({
  field: { marginBottom: theme.spacing(2) },
  sectionLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    margin: theme.spacing(1, 0, 1),
  },
  errorText: { color: theme.palette.error.main, fontSize: "0.8rem", marginRight: "auto", paddingLeft: 8 },
}));

export default function MetaCampaignModal({ open, onClose, campaign, onSaved }) {
  const classes = useStyles();
  const { wabaConnections, contactLists, form, set, error, saving, handleSubmit } =
    useMetaCampaignModal({ open, campaign, onSaved, onClose });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>{campaign ? "Editar Campaña Meta" : "Nueva Campaña Meta"}</DialogTitle>

      <DialogContent dividers>
        <TextField
          className={classes.field}
          fullWidth size="small" variant="outlined"
          label="Nombre de la campaña *"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          inputProps={{ maxLength: 100 }}
        />

        <FormControl fullWidth variant="outlined" size="small" className={classes.field}>
          <InputLabel>Conexión WABA (WhatsApp Oficial) *</InputLabel>
          <Select
            label="Conexión WABA (WhatsApp Oficial) *"
            value={form.whatsappId}
            onChange={(e) => {
              set("whatsappId", e.target.value);
              // cambiar de conexión invalida la plantilla/mapeo previos
              set("templateId", "");
              set("templateVariables", null);
            }}
          >
            {wabaConnections.length === 0 && (
              <MenuItem value="" disabled>No hay conexiones WABA (Meta)</MenuItem>
            )}
            {wabaConnections.map((w) => (
              <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          className={classes.field}
          fullWidth size="small" variant="outlined"
          label="Fecha y hora de envío *"
          type="datetime-local"
          value={form.scheduledAt}
          onChange={(e) => set("scheduledAt", e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        <FormControl fullWidth variant="outlined" size="small" className={classes.field}>
          <InputLabel>Lista de contactos *</InputLabel>
          <Select
            label="Lista de contactos *"
            value={form.contactListId}
            onChange={(e) => set("contactListId", e.target.value)}
          >
            {contactLists.length === 0 && (
              <MenuItem value="" disabled>No hay listas de contactos</MenuItem>
            )}
            {contactLists.map((cl) => (
              <MenuItem key={cl.id} value={cl.id}>{cl.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider style={{ margin: "8px 0 16px" }} />
        <div className={classes.sectionLabel}>Plantilla y variables</div>
        <CampaignTemplateSection
          values={form}
          setFieldValue={set}
          whatsappId={form.whatsappId}
          disabled={saving}
        />
      </DialogContent>

      <DialogActions>
        {error && <span className={classes.errorText}>{error}</span>}
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={saving || !!error}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? "Guardando..." : campaign ? "Actualizar" : "Crear campaña"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
